// extracted by mini-css-extract-plugin
module.exports = {"root":"__0VKWnmAr"};